export default "__VITE_ASSET__DKLb3N5c__"